import { graphql } from 'react-apollo';
import { userVideoResourceStatusListQuery } from 'legacy/src/queries';

const withVideosStatus = graphql(userVideoResourceStatusListQuery, {
  options: ({
    masterSubjectId,
    studentContext,
    videos,
    userData: {
      me: { initId: myId },
      isStudent,
      isTeacher,
    },
  }) => {
    const isTeacherWithStudentContext =
      isTeacher && studentContext && studentContext.hasContext;
    const skip = !(
      (isStudent || isTeacherWithStudentContext) &&
      (videos || []).length > 0
    );
    const videoIds = (videos || []).map(({ videoId }) => videoId);
    const userId = isTeacherWithStudentContext
      ? studentContext.studentId
      : myId;

    return {
      skip,
      variables: {
        userIds: [userId],
        videoIds,
        subjectId: masterSubjectId,
      },
      fetchPolicy: 'network-only',
    };
  },
  props: ({ data }) => {
    const {
      loading: isLoadingWatchedVideos,
      userVideoResourceStatusList: stringifiedData,
    } = data;
    const { dailyVideoStatus } = JSON.parse(stringifiedData || '{}');
    const { userVideoResourceStatusList } = dailyVideoStatus || {};
    const [userStatus] = userVideoResourceStatusList || [];
    const watchedVideoIds = userStatus
      ? (userStatus.data || [])
          .filter(({ status }) => status === 'COMPLETE')
          .map(({ resourceId }) => resourceId)
      : [];

    return {
      isLoadingWatchedVideos,
      watchedVideoIds,
    };
  },
});

export default withVideosStatus;
